/* unplugin-vue-components disabled */import script from "./appidDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./appidDialog.vue?vue&type=script&setup=true&lang=js"

import "./appidDialog.vue?vue&type=style&index=0&id=577a3184&lang=scss&scoped=true"

import exportComponent from "D:\\igencloud_team\\ident-doc-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-577a3184"]])

export default __exports__